exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:FuturaStd-Book;src:url(" + require("./FuturaStd-Book.otf") + ")}@font-face{font-family:PlayfairDisplay-Regular;src:url(" + require("./PlayfairDisplay-Regular.otf") + ")}@font-face{font-family:PlayfairDisplay-Bold;src:url(" + require("./PlayfairDisplay-Bold.otf") + ")}@font-face{font-family:Poppins-Light;src:url(" + require("./Poppins-Light.otf") + ")}@font-face{font-family:Poppins-Medium;src:url(" + require("./Poppins-Medium.otf") + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/fonts/fonts.css
// module id = 720
// module chunks = 0